module.exports = __webpack_public_path__ + "img/Egypt.69c7afdc.png";